import PayModal from "../Modals/PayModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const NewButtonWithIcon = ({
  title = null,
  showPayModal,
  setShowPayModal,
  handleClick,
  color = "success",
  className = "",
  icon = faAdd,
  /** optional node shown after the title, e.g. a counter of running uploads */
  badge = null,
}) => {
  const { t } = useTranslation();

  title = title ? title : t("Backend.Buttons.New");
  return (
    <>
      <PayModal show={showPayModal} setShow={setShowPayModal} />
      <button
        type="button"
        className={`btn btn-${color} hstack gap-2 ${className}`}
        onClick={(e) => {
          typeof handleClick === "function" && handleClick(e);
        }}
      >
        <FontAwesomeIcon icon={icon} />
        <span className="vr"></span>
        {title}
        {badge}
      </button>
    </>
  );
};

export default NewButtonWithIcon;
